import request from "./base_requests";

const base_url = process.env.VUE_APP_API;

export default {
    registration_app(data) {
        return request.post(base_url + '/register', data)
    },
    login_app(data) {
        return request.post(base_url + '/login', data)
    },
    logout_app() {
        return request.get(base_url + '/logout')
    },
    get_details_user_app(data) {
        return request.post(base_url + '/details', data)
    },
    create_user_on_dashboard(data) {
        return request.post(base_url + '/dashboard-integration/clients/create', data)
    },
    create_free_subscription(data) {
        return request.post(base_url + '/dashboard-integration/payments/create')
    },
    update_info_subscription_after_pay() {
        return request.post(base_url + '/dashboard-integration/payments/check_subscription')
    },
    terminate_subscription(data) {
        return request.post(base_url + '/dashboard-integration/payments/cancel', data)
    },
    get_plans(data) {
        return request.get(base_url + '/dashboard-integration/plans', data)
    },
    get_local_plans(data) {
        return request.get(base_url + '/dashboard-integration/local_plans', data)
    },
    get_subscription_info(data) {
        return request.post(base_url + '/dashboard-integration/subscriptions', data)
    },
    //support requests
    get_all_tickets(page = 1) {
        return request.get(base_url + '/dashboard-integration/tickets?page=' + page)
    },
    get_ticket_messages(data) {
        return request.post(base_url + '/dashboard-integration/tickets/messages', data)
    },
    get_statistics(data) {
        return request.post(base_url + '/contents/statistics', data)
    },
    get_statistics_v3(data) {
        return request.post(base_url + '/contents/statistics/v3', data)
    },
    get_blog() {
        return request.get(base_url + '/blog/list');
    },
    upload_blog_images(data) {
        return request.post(base_url + '/blog/upload-image', data);
    },
    create_new_blog_note(data) {
        return request.post(base_url + '/blog/create', data);
    },
    update_blog_note(data) {
        return request.post(base_url + '/blog/update/' + data.id, data);
    },
    get_blog_note(note_id) {
        return request.get(base_url + '/blog/show/' + note_id);
    },
    delete_blog_note(note_id) {
        return request.post(base_url + '/blog/delete/' + note_id, note_id);
    },
    get_public_blog() {
        return request.get(base_url + '/blog/public/list');
    },
    get_blog_note_by_name(name) {
        return request.get(base_url + '/blog/public/show/' + name);
    },

    send_event_reset_password() {
        return request.post(base_url + '/events/reset_password');
    },
    send_event_export_users(data) {
        return request.post(base_url + '/events/export_users', data)
    },
    reset_counter_messages_for_ticket(data) {
        return request.patch(base_url + '/dashboard-integration/tickets/reset_counter', data)
    },
    check_new_messages() {
        return request.get(base_url + '/dashboard-integration/tickets/check_messages');
    }
}
